import $http from '@/libs/axios'

class MobileDesignAPIs {
  static async getThemesList() {
    return (await $http.get('/mobile/themes/list')).data
  }

  static async getTheme(id: number) {
    return (await $http.get(`/mobile/themes/view/${id}`)).data
  }

  static async create(payload: any) {
    return (await $http.post('/mobile/themes/create', payload)).data
  }

  static async update(id: number, payload: any) {
    return (await $http.post(`/mobile/themes/update/${id}`, payload)).data
  }

  static async delete(id: number) {
    return (await $http.delete(`/mobile/themes/${id}`)).data
  }

  static async activate(id: number) {
    return (await $http.get(`/mobile/themes/activate/${id}`)).data
  }

  static async duplicate(id: number) {
    return (await $http.get(`/mobile/themes/duplicate/${id}`)).data
  }
}

export default MobileDesignAPIs
